export type InfoIconTemplateProps = {
  size?: number;
  color?: string;
  strokeWidth?: number;
};

export const InfoIconTemplate = ({
  size = 12,
  color = "#C6C6C6",
  strokeWidth = 1,
}: InfoIconTemplateProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7" stroke={color} strokeWidth={strokeWidth} fill="none"/>
      <path
        d="M8 3.5V3.5M8 6.5V12.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}; 